import { IonIcon } from "@ionic/react";
import { radioButtonOff, radioButtonOn } from "ionicons/icons";

import "./AccessControlCell.css";

export type AccessControlPermissonAttributes = string[];

export interface AccessControlPermission {
  role: string;
  resource: string;
  action: string;
  allowed: boolean;
  onClick?: (e: React.MouseEvent) => void;
  // Cells the user cannot toggle: always-on (e.g. Admin, who may always
  // post) or not applicable to this row (e.g. Guest/None for a mode-backed
  // row rather than a casbin one). No new colour - `medium` is the same
  // muted token already used for disabled/loading state elsewhere in this
  // app (SettingsTab, GroupSearch, MembersTab). Defaults to true so every
  // existing caller (the casbin grid) is unaffected.
  interactive?: boolean;
}

type AccessControlCellProps = AccessControlPermission;

const AccessControlCell: React.FC<AccessControlCellProps> = ({
  role: _role,
  resource: _resource,
  action: _action,
  allowed,
  onClick,
  interactive = true,
}) => {
  let colour = "danger";
  let icon = radioButtonOff;

  if (allowed) {
    colour = "success";
    icon = radioButtonOn;
  } else if (!interactive) {
    colour = "medium";
  }

  return (
    <IonIcon
      icon={icon}
      color={colour}
      onClick={interactive ? onClick : undefined}
      size="large"
    />
  );
};

export default AccessControlCell;
